import { Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Home from "../Screens/Home";
import Login from "../Screens/Login";

export default function NavigateRoute() {
  return (
    <>
      <Routes>
        <Route
          exact
          path="/"
          element={<PrivateRoute>{<Home />}</PrivateRoute>}
        />
        <Route exact path="/login" element={<Login />} />
      </Routes>
    </>
  );
}
